import { Box, Typography } from "@mui/material";
import { formatCash as formatCashAmount, formatPrice } from "../../utils/formatNumber";
import SDCoinIcon from "./SDCoinIcon";

const amountLineSx = {
  fontWeight: 700,
  fontSize: "1.25rem",
  lineHeight: 1.25,
};

export default function CashAndGemsAmount({
  cashAmount = 0,
  gemAmount = 0,
  sdCoinAmount = 0,
  formatCash,
}) {
  const cashValue = formatCash
    ? formatCash(cashAmount)
    : formatCashAmount(cashAmount || 0);

  return (
    <Box sx={{ mb: 0.5 }}>
      <Typography sx={{ ...amountLineSx, opacity: 0.95, mt: 0.25 }}>
        💎 {formatPrice(gemAmount || 0)}
      </Typography>
      <Typography
        sx={{
          ...amountLineSx,
          opacity: 0.95,
          mt: 0.25,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <SDCoinIcon size={20} />
        {formatPrice(sdCoinAmount || 0)}
      </Typography>
    </Box>
  );
}
